import {Possessed} from "../../Possessed";
import {SimplePresentation} from "./SimplePresentationRunner";

export class HideUIPresentation extends SimplePresentation {

    constructor() {
        super("Hide UI Presentation");
    }

    shouldRun(): boolean {
        return Possessed.model.isLastFreespin() || Possessed.model.isLastRespin();
    }

    buildTimeline() {
        const tl = this.tl;

        tl.add(Possessed.crucifixReel.fadeOut());
        tl.add(Possessed.reelView.reelCross.updateHotZones(0));
    }
}